import { HttpClient } from '#client/http/index'
import { CreateContactParams } from '#client/resources/index'

export const create = async (
  { httpClient }: { httpClient: HttpClient },
  params: CreateContactParams,
) => {
  return await httpClient.put(`/user/contacts/send`, params)
}
